import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/percepcion-parametro-diverso-cuenta-contable-area';

/**
 * GET Cuentas Contables por Área de un Parámetro Diverso
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPercepcionParametroDiversoCuentasContablesArea = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Cuenta Contable por Área (detalle)
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPercepcionParametroDiversoCuentaContableArea = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Cuenta Contable por Área
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPercepcionParametroDiversoCuentaContableArea = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Cuenta Contable por Área
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPercepcionParametroDiversoCuentaContableArea = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Cuenta Contable por Área
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePercepcionParametroDiversoCuentaContableArea = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
